// Englische Fassung von ../de/common.ts.
//
// Die Typ-Annotation ist die Paritätsprüfung: fehlt hier ein Key, den es in
// de/common.ts gibt, ist das ein Compiler-Fehler (TS2741) — steht hier einer zu
// viel, ebenfalls (TS2353). Beides zeigt auf DIESE Datei, nicht auf einen
// gemeinsamen Sammel-Katalog; deshalb kann jeder Bereichs-Worker seinen
// Namespace unabhängig fertigstellen.
import type { CommonKatalog } from "../de/common";

export const common: CommonKatalog = {
  abbrechen: "Cancel",
  bestaetigen: "Confirm",
  schliessen: "Close",
  speichern: "Save",
  loeschen: "Delete",
  bearbeiten: "Edit",
  anlegen: "Create",
  verwerfen: "Discard",
  zurueck: "Back",
  aktualisieren: "Refresh",
  herunterladen: "Download",
  erneutVersuchen: "Try again",
  speichernFehlgeschlagen: "Saving failed",
};
